import { Navigate, useRoutes, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import WindowLayout from './layouts/WindowLayout';
import AuditLive from './pages/AuditLive';
import Live from './pages/Live';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import ListAudits from './pages/ListAudits';
import ListAuditsIndia from './pages/ListAuditsIndia';
import DashboardApp from './pages/DashboardApp';
import DashboardAppInd from './pages/DashBoardAppInd';
import DashboardDemo from './pages/DashboardDemo';

import Analytics from './pages/Analytics';
import AssignAnalytics from './pages/AssignAnalytics';
import Notifications from './pages/Notifications';
import MonTimings from './pages/MonTimings';
import LicenceUpgrade from './pages/LicenceUpgrade';
import Cameras from './pages/Cameras';
import { isAccess } from './utils/responseHandler';
import { getRestrictedLandingPage, isClientRestricted, isPageAllowedForClient } from './utils/clientRouteAccess';
import Clients from './pages/Clients';
import Devices from './pages/Devices';
import LiveCameras from './pages/LiveCameras';
import EmpProductivity from './pages/EmpProductivity';
import Servers from './pages/Servers';
import JKODashboard from './pages/JKODashboard';
import AutoLogin from './pages/AutoLogin';
import Reports from './pages/Reports';
import USReports from './pages/USReports';
import JFWReport from './pages/JFWReport';
import DevicesReport from './pages/DevicesReport';
import HeadCountReport from './pages/HeadCountReport';
import HeadCountDashboard from './pages/HeadCountDashboard';
import HeadCountInput from './pages/HeadCountInput';
import LicensePlate from './pages/LicensePlate';
import Timelaps from './pages/Timelaps';
import ShiftTme from './pages/ShiftTme';
// import NetrawalaEntry from './pages/netrawalaEntry';
// ----------------------------------------------------------------------
import DeploymentReports from './pages/DeploymentReports';
import CreditSettings from './pages/CreditSettings';
import Groupsdetails from './sections/settings/Groupsdetails';
import ProtocolsOld from './sections/settings/protocolsOld';
import Protocols from './sections/settings/protocols';
//import ProtocolsLatest from './sections/settings/ProtocolsLatest';
import VideoArchives from './pages/VideoArchives';
import ClientContacts from './sections/clientContacts/ClientContacts';
import DashBoardDepApp from './pages/DashBoardDepApp';
import AddAgent from './sections/settings/AddAgent';
import DashBoardMdPSIT from './pages/DashBoardMdPSIT';
//
import ClientBilling from './sections/Billing/ClientBilling';
import ClientAddPlan from './sections/Billing/ClientAddPlan';
import ViewPlans from './sections/Billing/ViewPlans';
import ReportsInfc from './pages/ReportsInfc';
import VerificationPage from './pages/verificationPage';
import ClientDeviceForm from './sections/devices/ClientDeviceForm';
import { element } from 'prop-types';
import MdReports from './sections/reports/MdReports';
// Mohini 
import AddShow from './sections/Mohini/AddShow';
import MohiniReports from './sections/Mohini/MohiniReports';
import MohiniDashBoard from './sections/Mohini/MohiniDashBoard';
//New login for same clients
import AddNewLogin from './sections/settings/AddNewLogin';
import ClientConsolidationLogin from './sections/settings/ClientConsolidationLogin';

import Dashboard from './pages/Dashboard';
import EmailTimings from './sections/reports/EmailTimings';
import EmailReports from './sections/clientContacts/EmailReports';
import DailyEmailReports from './sections/reports/DailyEmailReports';
import NetrawalaEntry from './pages/netrawalaEntry';
import AddShiftsNeterwala from './pages/addShiftsNeterwala';
import NetrawalaEntryMonthly from './pages/netrawalaEntryMonthly';


//Event Reports
import FalseEvents from './sections/EventReports/FalseEvents';
import IndividualEvents from './sections/EventReports/IndividualEvents';
import TotalEvents from './sections/EventReports/TotalEvents';

import ClientWiseCEC from './pages/clientWise/ClientWiseCEC';
import ClientWiseGEC from './pages/clientWise/ClientWiseGEC';
import ClientWiseLC from './pages/clientWise/ClientWiseLC';

// camera Wise
import CameraWiseCompEC from './pages/CameraWise/CameraWiseCompEC';
import CameraWiseFEC from './pages/CameraWise/CameraWiseFEC';
import CameraWiseGEC from './pages/CameraWise/CameraWiseGEC';
import CameraWiseLC from './pages/CameraWise/CameraWiseLC';
import CameraWiseTEC from './pages/CameraWise/CameraWiseTEC';

import EscalatedVideo from './pages/EscalatedVideo';
import VideoStreamPlayer from './pages/VideoStreamPlayer';
import ResetPassword from './pages/ResetPassword';

// agent wise
import AgentWiseReport from './pages/AgentWiseReport';
import AgentWiseLatency from './pages/AgentWise/AgentwiseLatency';
import AgentwiseTEC from './pages/AgentWise/AgentwiseTEC';
import AgentwiseFEC from './pages/AgentWise/AgentwiseFEC';

// agent consolidated
import TotalEscalatedAGC from './pages/AgentConsolidated/TotalEscalatedAGC';
import TotalEventsAGC from './pages/AgentConsolidated/TotalEventsAGC';
import FalseEventsAGC from './pages/AgentConsolidated/FalseEventsAGC';
import TrueEventsAGC from './pages/AgentConsolidated/TrueEventsAGC';

import ClientAssign from './pages/ClientAssign';
import LicensePlateRecognitionReport from './pages/LicensePlateRecognitionReport';
import VehicalTrackingInfo from './pages/VehicalTrackingInfo';
import FaceList from './pages/FaceList';
import FaceRegistration from './pages/FaceRegistration';

import { initializeFirebase, requestPermissionAndToken } from 'src/webPushMessage'
import { onMessage } from 'firebase/messaging'
import axios from 'axios';
import { getURL } from './utils/config';
import { handleResponse } from './utils/responseHandler';
import DashboardSRMB from './pages/DashboardSRMB';
import NeterwalaDashboard from './pages/NeterwalaDashboard';
import FaceRegisterListTab from './pages/FaceRegisterListTab';
import EmployeeTrackingInfo from './pages/EmployeeTrackingInfo';
import USClientsDashBoard from './pages/USClientsDashBoard';
import LiveCamerasGym from './pages/LiveCamerasGym';
import ProtocolIndividual from './sections/settings/protocolIndividual';
import PasswordManagement from './sections/settings/PasswordManagement';
import AddUserAccess from './sections/settings/AddUserAccess';
import OperationsTeam from './sections/settings/OperationsTeam';
import ProtocolIndividualAll from './sections/settings/protocolIndividualAll';
import Signin from './pages/Signin';
import Model from './pages/Model';
import Combo from './pages/Combo';
import CameraModelComboConfig from './pages/CameraModelComboConfig';
import ClientCameras from './pages/ClientCameras';
import LiveHeatmap from './pages/LiveHeatmap';
import LiveReports from './pages/LiveReports';
import LiveTimezones from './pages/LiveTimezones';
import apiAxios from './axios';

import AttendanceDetails from './pages/AttendanceDetails';

import Credits from './sections/reports/Credits';
import BillingDashboard from 'src/sections/Billing/BillingDashboard'
import CameraGrouping from './sections/reports/CameraGrouping';
import InvoiceGrouping from './sections/reports/InvoiceGrouping';
import {
  buildAuthSnapshot,
  clearPersistedAuthSnapshot,
  clearTabLoggedOutMark,
  ensureTabSessionId,
  getPersistedAuthSnapshot,
  hasActiveAuth,
  isTabMarkedLoggedOut,
  isAuthSyncEventKey,
  markTabLoggedOut,
  parseAuthSyncEvent,
  persistAuthSnapshot
} from './utils/authSync';
import { getAppStorageItem } from './utils/storageProxy';
import ModelSetup from './pages/ModelSetup';
import Test from './pages/Test';
import SharedFootage from './pages/SharedFootage';
import Report from './pages/Report';
import Configuration from './pages/Configuration';

const getStoredUserValues = () => ({
  "access_token": getAppStorageItem('access_token'),
  "token_type": getAppStorageItem('token_type'),
  "ID": getAppStorageItem('ID'),
  "IsLicenseBase": getAppStorageItem('IsLicenseBase'),
  "IsAgentBased": getAppStorageItem('IsAgentBased'),
  "name": getAppStorageItem('name'),
  "displayname": getAppStorageItem('displayname'),
  "logo_url": getAppStorageItem('logo_url'),
  "user_type": getAppStorageItem('user_type'),
  "client_id": getAppStorageItem('client_id'),
  "EnvironmentType": getAppStorageItem('EnvironmentType')
});

const getInitialAuthState = () => {
  const token = getAppStorageItem('access_token');
  const authId = getAppStorageItem('authId') || 0;
  const userType = getAppStorageItem('user_type');
  const tokenType = getAppStorageItem('token_type');
  const persistedSnapshot = getPersistedAuthSnapshot();

  if (token && parseInt(authId, 10) === 1) {
    return {
      token,
      authId,
      userType,
      tokenType,
      userData: getStoredUserValues()
    };
  }

  if (hasActiveAuth(persistedSnapshot)) {
    return {
      token: persistedSnapshot.access_token,
      authId: persistedSnapshot.authId,
      userType: persistedSnapshot.user_type,
      tokenType: persistedSnapshot.token_type,
      userData: {
        ...getStoredUserValues(),
        access_token: persistedSnapshot.access_token,
        token_type: persistedSnapshot.token_type,
        user_type: persistedSnapshot.user_type
      }
    };
  }

  return {
    token: null,
    authId: 0,
    userType: null,
    tokenType: null,
    userData: getStoredUserValues()
  };
};

const hasBootstrappedAuth = (authState) =>
  Boolean(authState?.token) && parseInt(authState?.authId, 10) === 1;

const EMPTY_USER_VALUES = {
  "access_token": null,
  "token_type": null,
  "ID": null,
  "IsLicenseBase": null,
  "IsAgentBased": null,
  "name": null,
  "displayname": null,
  "logo_url": null,
  "user_type": null,
  "client_id": null,
  "EnvironmentType": null
};

const AUTH_SESSION_KEYS = [
  'access_token',
  'token_type',
  'authId',
  'ID',
  'client_id',
  'user_type',
  'name',
  'displayname',
  'profile_name',
  'logo_url',
  'logo',
  'IsLicenseBase',
  'IsAgentBased',
  'EnvironmentType',
  'Type',
  'client_type',
  'assigned_locations'
];

function RedirectToLogin() {
  const { pathname, search } = window.location;
  if (pathname && pathname !== '/login' && pathname !== '/') {
    sessionStorage.setItem('redirectAfterLogin', pathname + search);
  }
  return <Navigate to="/login" replace />;
}

export default function Router() {
  const initialAuthState = getInitialAuthState();
  const [token, setToken] = useState(initialAuthState.token);
  const [authId, setAuthId] = useState(initialAuthState.authId);
  const [userType, setUserType] = useState(initialAuthState.userType);
  const [userData, setuserData] = useState(initialAuthState.userData);
  const [clientId,setClientId] = useState(initialAuthState.client_id)
  const [access, setAccess] = useState(isAccess())
  const authSnapshotRef = useRef(getPersistedAuthSnapshot() || buildAuthSnapshot(initialAuthState));

  const isReseller = userType === '40';
  
  const applyLoggedOutState = () => {
    AUTH_SESSION_KEYS.forEach((key) => {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    });

    setToken(null);
    setAuthId(0);
    setUserType(null);
    setuserData(EMPTY_USER_VALUES);
    setAccess(false);
    markTabLoggedOut();
    clearPersistedAuthSnapshot();
    authSnapshotRef.current = null;
    delete apiAxios.defaults.headers.common.Authorization;
  };

  const syncAuthFromStorage = () => {
    const nextToken = getAppStorageItem('access_token');
    const nextAuthId = getAppStorageItem('authId') || 0;
    const nextUserType = getAppStorageItem('user_type');
    const nextTokenType = getAppStorageItem('token_type');
    const nextSnapshot = buildAuthSnapshot({
      access_token: nextToken,
      token_type: nextTokenType,
      authId: nextAuthId,
      user_type: nextUserType
    });

    if (isTabMarkedLoggedOut() && !hasActiveAuth(nextSnapshot)) {
      applyLoggedOutState();
      return;
    }

    setToken(nextToken);
    setAuthId(nextAuthId);
    setUserType(nextUserType);
    setuserData(getStoredUserValues());
    setAccess(isAccess());

    if (hasActiveAuth(nextSnapshot)) {
      clearTabLoggedOutMark();
      authSnapshotRef.current = persistAuthSnapshot(nextSnapshot);
      apiAxios.defaults.headers.common.Authorization = `${nextTokenType} ${nextToken}`;
    } else {
      clearPersistedAuthSnapshot();
      authSnapshotRef.current = null;
      delete apiAxios.defaults.headers.common.Authorization;
    }
  };

  const shouldHandleLogoutSync = (eventAuth) => {
    const currentAuth = authSnapshotRef.current || getPersistedAuthSnapshot();
    if (!eventAuth || !currentAuth) return false;

    const eventId = String(eventAuth.ID || '');
    const currentId = String(currentAuth.ID || '');
    const eventClientId = String(eventAuth.client_id || '');
    const currentClientId = String(currentAuth.client_id || '');
    const eventUserType = String(eventAuth.user_type || '');
    const currentUserType = String(currentAuth.user_type || '');

    if (eventId && currentId && eventClientId && currentClientId) {
      return eventId === currentId &&
        eventClientId === currentClientId &&
        eventUserType === currentUserType;
    }

    if (eventAuth.access_token && currentAuth.access_token) {
      return eventAuth.access_token === currentAuth.access_token;
    }

    return (
      eventId === currentId &&
      eventClientId === currentClientId &&
      eventUserType === currentUserType
    );
  };

  useEffect(() => {
    ensureTabSessionId();

    if (hasBootstrappedAuth(initialAuthState)) {
      clearTabLoggedOutMark();
    }

    const handleStorage = (event) => {
      if (isAuthSyncEventKey(event.key)) {
        const authEvent = parseAuthSyncEvent(event.newValue);
        if (authEvent?.type === 'logout' && shouldHandleLogoutSync(authEvent.auth)) {
          applyLoggedOutState();
        }
        return;
      }

      if (
        event.key &&
        ![
          'access_token',
          'token_type',
          'authId',
          'user_type',
          'isAccess',
          'LastUpdatedTime'
        ].includes(event.key)
      ) {
        return;
      }
      syncAuthFromStorage();
    };

    syncAuthFromStorage();
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);



  // console.log('userData:', JSON.stringify(userData));
  // console.log('EnvironmentType:',userData.EnvironmentType)

  const DASH_LAYOUT = [{
    path: '/',
    element: <DashboardLayout setToken={setToken} userType={Number(userType)} userData={userData} />,
    children: [
      { path: '/', element: (Number(userData.client_id) === 733  || Number(userData.client_id) === 917 )? <JKODashboard/> :
                                                                    (Number(userType) === 9 || Number(userType) === 40) ? <Clients clientId={userData.client_id} userType={userData.user_type} isReseller={isReseller}></Clients>:
                                                                    //Number(userType) === 8 ? <Navigate to="/dashboard" replace />:
                                                                    Number(userData.client_id) === 765 ?<NeterwalaDashboard  clientId={userData.client_id}/>:
                                                                    Number(userData.client_id) === 883 ?<MohiniDashBoard  clientId={userData.client_id}/>:
                                                                    Number(userData.client_id) === 58 ?<BillingDashboard  clientId={userData.client_id}/>:
                                                                    Number(userType) === 8 ? <Dashboard />:
                                                                    // Number(userData.client_id) === 1191 ? <VehicalTrackingInfo />:
                                                                    Number(userData.client_id) === 1191 ? <DashboardSRMB />:
                                                                    Number(userData.client_id) === 1262 ? <DashboardApp clientId={userData.client_id} userType={userData.user_type} />:
                                                                    Number(userType) === 37 ? <DashBoardMdPSIT clientId={userData.client_id} userType={userData.user_type}/>:
                                                                    // Number(userType) === 863 ?<DashboardApp clientId={userData.client_id} userType={userData.user_type} />:
                                                                    // Number(userData.IsAgentBased) === 0 &&  Number(userData.client_id) !== 883 ?<DashboardAppInd clientId={userData.client_id} userType={userData.user_type} />:
                                                                    // Number(userData.client_id) === 883 ?<MohiniDashBoard  clientId={userData.client_id}/>:
                                                                    Number(userData.IsAgentBased) === 0  ? <DashboardAppInd clientId={userData.client_id} userType={userData.user_type} />:
                                                                    Number(userData.ID) === 1371 ? <DashboardDemo clientId={userData.client_id} userType={userData.user_type} />:
                                                                    <USClientsDashBoard clientId={userData.client_id} userType={userData.user_type}/> 
                                                                  },

      // { path: '/', element: Number(userData.client_id) === 733 ? <JKODashboard/> :<DashBoardDepApp clientId={userData.client_id} userType={userData.user_type} /> },
      // { path: '/', element: Number(userData.client_id) === 765 ? <NetrawalaEntry/> :<DashboardApp clientId={userData.client_id} userType={userData.user_type} /> },
      
      { path: 'escalatedEventsUS', element:((userType!=='9' && userType !=='8' && userType !=='40')? <ListAudits userType={userData.user_type} setToken={setToken} clientId={userData.client_id} IsAgentBased={userData.IsAgentBased}/> :<NotFound/> )},
      
      { path: 'us-reports', element:((userType!=='9' && userType !=='8' && userType !=='40')? <USReports  userType={userData.user_type} setToken={setToken} clientId={userData.client_id} IsAgentBased={userData.IsAgentBased}/> :<NotFound/> ) },

      
      { path: 'audits', element:((userType!=='9' && userType !=='8' && userType !=='40')? (Number(userData.client_id) === 1262) ? <ListAudits userType={userData.user_type} setToken={setToken} clientId={userData.client_id} IsAgentBased={userData.IsAgentBased}/> : <ListAuditsIndia userType={userData.user_type} setToken={setToken} clientId={userData.client_id} IsAgentBased={userData.IsAgentBased}/> :<NotFound/> )},                                                           

      // { path: 'products', element: <ListAudits /> },
      { path: 'neterwalaDashboard', element: <NeterwalaDashboard /> },

      { path:'report', element:<Report/>},
      { path:'configuration', element:<Configuration/>},
      
      { path: 'live-audits', element: <AuditLive /> },
      { path: 'test', element: <Test /> },
      { path: 'DashboardDep', element: <DashBoardDepApp /> },
      { path: 'home', element: ((Number(userData.ID) === 1371) ? <DashboardDemo/> : <USClientsDashBoard />) },
      { path: 'DashboardSrmb', element: <DashboardSRMB /> },
      { path: 'DashboardMdPSIT', element: <DashBoardMdPSIT /> },
      { path: 'Dashboardapp', element: <DashboardAppInd /> },
      { path: 'MohiniDashboard', element: <MohiniDashBoard /> },

      { path: 'analytics', element:(userType!=='2' ? <Analytics userType={9} /> : <Navigate to="/404" replace />) },
      { path: 'model-setup', element:(userType!=='2' ? <ModelSetup userType={9} /> : <Navigate to="/404" replace />) },
      { path: 'model-config', element:(userType!=='2' ? <Model/> : <Navigate to="/404" replace />) },
      { path: 'combo-model-config', element:(userType!=='2' ? <Combo/> : <Navigate to="/404" replace />) },
      

      { path: 'assignAnalytics', element:(userType!=='2' ? <AssignAnalytics userType={9} /> : <Navigate to="/404" replace />) },
      { path: 'mon-timings', element: <MonTimings /> },
      { path: 'camerasInfo', element:((userType!=='9' || userType!=='40') ? <Cameras /> : <Navigate to="/404" replace /> )},
      { path: 'live', element: <LiveCameras isReseller={isReseller}/> },
      { path: 'livegym', element: <LiveCamerasGym /> },
      { path: 'clients', element:( userType!=='2' ? <Clients isReseller={isReseller}/>: <Navigate to="/404" replace /> )},
      { path: 'cameras', element:(userType!=='2' ? <Devices isReseller={isReseller}/>: <Navigate to="/404" replace />) },
      { path: 'emp-productivity', element: <EmpProductivity /> },
      { path: 'jfw-reports', element: <JFWReport /> },
      { path: 'servers', element:(userType!=='2' ? <Servers />:<Navigate to="/404" replace />) },
      { path: 'reports', element: <Reports /> },
      { path: 'reportsinfc', element: <ReportsInfc /> },
      { path: 'head-count-report', element: <HeadCountReport /> },
      { path: 'head-count-dashboard', element: <HeadCountDashboard /> },
      { path: 'head-count-input', element: <HeadCountInput /> },
      { path: 'deploymentReports', element:(userType!=='2' ? <DeploymentReports />:<Navigate to="/404" replace /> )},
      { path: 'creditSettings', element:((userType!=='2' && (userType === '41' || userType === '42' || userType === '6'))) ? <CreditSettings />:<Navigate to="/404" replace /> },
      { path: 'devices-report', element: <DevicesReport /> },
      { path: 'notifications/*', element: <Notifications />},
      { path: 'license-plate', element: <LicensePlate /> },
      { path: 'addAgent', element: (userType!=='2' ? <AddAgent /> : <Navigate to="/404" replace />) },
      //{ path: 'Add-Agent', element: (userType !== '2' ? (userType === '8' ? <Navigate to="/dashboard" replace /> : <AddAgent />) : <Navigate to="/404" replace />) },
      { path: 'loginCreations', element: (userType!=='2' ? <AddNewLogin isReseller={isReseller}/> : <Navigate to="/404" replace />) },
      { path: 'clientConsolidationlogin', element: (userType!=='2' ? <ClientConsolidationLogin isReseller={isReseller}/> : <Navigate to="/404" replace />) },
      { path: 'clientassign', element: (userType!=='2' ? <ClientAssign /> : <Navigate to="/404" replace />) },
      // { path: 'dailyEmailReports', element: (userType !== '2' ? <ClientContacts /> : <Navigate to="/404" replace />) },
      // { path: 'dailyEmailTime', element: (userType !== '2' ? <DailyEmailReports /> : <Navigate to="/404" replace />) },
      { path: 'emailReports', element: (userType !== '2' ? <EmailReports isReseller={isReseller}/> : <Navigate to="/404" replace />) },
      { path: 'emailTimings', element: (userType !== '2' ? <EmailTimings isReseller={isReseller} /> : <Navigate to="/404" replace />) },
      { path: 'credits', element: (userType !== '2' ? <Credits /> : <Navigate to="/404" replace />) },
      { path: 'price', element: (userType !== '2' ? <CameraGrouping /> : <Navigate to="/404" replace />) },
      { path: 'invoiceGroupingTIime', element: (userType !== '2' ? <InvoiceGrouping /> : <Navigate to="/404" replace />) },
      { path: 'timelaps', element: <Timelaps /> },
      { path: 'shifttime', element: <ShiftTme /> },      
      // { path: 'group-settings', element: <Groups /> },
      { path: 'neterwala', element: <NetrawalaEntry /> },
      { path: 'neterwalaMonth', element: <NetrawalaEntryMonthly /> },   
      { path: 'addshifts', element: <AddShiftsNeterwala /> },      
      { path: 'groups', element:(userType!=='2' ? <Groupsdetails isReseller={isReseller}/> : <Navigate to="/404" replace />)},
      { path: 'protocols-old', element:(userType!=='2' ? <ProtocolsOld/> :<Navigate to="/404" replace />)},
      { path: 'protocols', element:(userType!=='2' ? <Protocols isReseller={isReseller}/> :<Navigate to="/404" replace />)},
      // { path: 'protocolsnew', element:(userType!=='2' ? <ProtocolsLatest/> :<Navigate to="/404" replace />)},
      // { path: 'protocol', element: (userType === '2' ? ([1266, 1302, 1316, 1320, 1357].includes(Number(userData.client_id)) ? <ProtocolIndividual /> : <ProtocolIndividualAll />) : <Navigate to="/404" replace />) },
      { path: 'protocol', element: (userType === '2' ? (((userData.EnvironmentType === "demo") && !([1262,1273].includes(Number(userData.client_id)))) ? <ProtocolIndividual /> : <ProtocolIndividualAll />) : <Navigate to="/404" replace />) },
  
      { path: 'changepassword', element: <PasswordManagement /> },      
      { path: 'addUserAccess', element: <AddUserAccess /> },  
      { path: 'operationsTeam', element: <OperationsTeam /> },      

      { path: 'playback', element:((userType!=='9' || userType!=='40')  ? <VideoArchives/> :<Navigate to="/404" replace />)},
      // { path: 'contacts', element:(userType!=='9' ? <ClientContacts /> : <Navigate to="/404" replace /> )},
      { path: 'generateBillForClient', element:(userType!=='2' ? <ClientBilling/> : <Navigate to="/404" replace />)},
      { path: 'addPlanToTheClient', element:(userType!=='2' ? <ClientAddPlan/> : <Navigate to="/404" replace />)},
      { path: 'viewPlans', element:(userType!=='2' ? <ViewPlans/> : <Navigate to="/404" replace />)},
      { path: 'register', element: <Register/>},
      { path:'add-client-camera',element:<ClientDeviceForm/>},
      { path: 'client-analytics',element:<Analytics/>},
      { path: 'mdReport', element: <MdReports/>}, 

      // Mohini
      { path: 'addShow', element: <AddShow/>},
      { path: 'mohiniReport', element: <MohiniReports/>},

      //event reports
      { path: 'falseEvents', element: <FalseEvents/> }, 
      { path: 'individualEvents', element: <IndividualEvents/>}, 
      { path: 'totalEvents', element: <TotalEvents/>}, 
      
      { path: 'dashboard', element: <Dashboard/>},
      { path : 'invoiceReport',element:<BillingDashboard/>}, 

      { path: 'VehicleTrackingInfo', element:((userType!=='9' || userType!=='40')  ? <VehicalTrackingInfo/>: <Navigate to="/404" replace />)},
      { path: 'licensePlateRecognitionReport', element:(Number(userData.client_id) === 1273 ? <LicensePlateRecognitionReport/>: <Navigate to="/404" replace />)},
      { path: 'face-list', element: <FaceList /> },
      { path: 'add-face', element: <FaceRegistration /> },
      { path: 'employee-attendance-details', element: <AttendanceDetails /> },
      { path: 'entry-face-details', element: <FaceRegisterListTab /> },
      { path: 'employee-production-details', element: <EmployeeTrackingInfo /> },


      { path: 'auto-login', element: <AutoLogin setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData} /> },
      { path: 'client-cameras', element:<ClientCameras /> },
      { path: 'live-heatmap', element: (Number(userData.client_id) === 1444 || Number(userData.client_id) === 1442) ? <LiveHeatmap /> : <Navigate to="/404" replace /> },
      { path: 'live-reports', element: [1444, 1442].includes(Number(userData.client_id)) ? <LiveReports /> : <Navigate to="/404" replace /> },
      { path: 'live-timezones', element: [1444, 1442].includes(Number(userData.client_id)) ? <LiveTimezones /> : <Navigate to="/404" replace /> },
      // { path: '*', element: <Navigate to={Number(userData.user_type) === 30 ? "/": "/audits"} replace /> },
      // { path: '*', element: <Navigate to={Number(userData.client_id) === 765 ? "/neterwala": "/neterwala"} replace /> }
      {
        path: '*',
        element: Number(userData.client_id) === 765
          ? <Navigate to="/neterwalaDashboard" replace />
          : Number(userData.user_type) === 30
            ? <Navigate to="/" replace />
            : Number(userData.user_type) === 9
              ? <Navigate to="/clients" replace /> 
              : Number(userData.user_type) === 40
              ? <Navigate to="/clients" replace /> 
              : Number(userData.user_type) === 37
              ? <Navigate to="/DashboardMdPSIT" replace /> 
              : Number(userData.user_type) === 1191
              ? <Navigate to="/DashboardSrmb" replace /> :
               (Number(userData.client_id) === 863)
               ? <Navigate to="/Dashboardapp" replace /> 
               : Number(userData.client_id) === 883 ?
               <Navigate to="/MohiniDashboard" replace />
              : Number(userData.user_type) === 8 ?
               <Navigate to="/dashboard" replace/>
              : Number(userData.client_id) === 1191 ? 
              <Navigate to="/VehicleTrackingInfo" replace />
              :
              (Number(userData.user_type) === 6 || Number(userData.user_type) === 41 || Number(userData.user_type) === 42) ? 
              <Navigate to="/invoiceReport" replace />
              :
              (Number(userData.IsAgentBased) === 0 && Number(userData.client_id) !== 1262) ? <Navigate to="/audits" replace />
              :(Number(userData.client_id) === 1262) ?<Navigate to="/" replace/> :<Navigate to="/home" replace />
      }
      
      // i want if userType 9 then redirect to Dashboard 
      
    ]
  },
  {
    path: '/',
    element: <WindowLayout />,
    children: [
      { path: 'audit-live/:gridview', element: <Live/> },
      { path: '404', element: <NotFound /> },
      // { path: 'licence', element: <LicenceUpgrade /> },      
      { path: '*', element: <Navigate to="/404" /> },

       // Dashboard paths for ops Client wise reports
       { path: '/clientwiseGEC-report/:date/:clientid/:hour', element: <ClientWiseGEC />},
       { path: '/clientwiseCEC-report/:date/:clientid/:hour', element: <ClientWiseCEC /> },
       { path: '/clientwiseLEC-report/:date/:clientid/:hour/:latency', element: <ClientWiseLC />},

       // Dashboard paths for ops Camera wise reports
      { path: '/camerawiseGEC-report/:date/:deviceid', element: <CameraWiseGEC /> },
      { path: '/camerawiseCEC-report/:date/:deviceid', element: <CameraWiseCompEC /> },
      { path: '/camerawiseTEC-report/:date/:deviceid', element: <CameraWiseTEC /> },
      { path: '/camerawiseFEC-report/:date/:deviceid', element: <CameraWiseFEC /> },
      { path: '/camerawiseLEC-report/:date/:deviceid/:latency', element: <CameraWiseLC /> },

      // ops agentwise report
      { path: '/agentwise-report/:date/:agentId/:hour', element: <AgentWiseReport /> },
      { path: '/agentwiseLatency-report/:date/:agentId/:hour', element: <AgentWiseLatency /> },
      { path: '/agentwise-tec/:date/:agentId/:hour', element: <AgentwiseTEC /> },
      { path: '/agentwise-fec/:date/:agentId/:hour', element: <AgentwiseFEC /> },

      // ops agent consolidated
      { path: '/agcTotalEvents-report/:date/:agentId', element: <TotalEventsAGC /> },
      { path: '/agcFalseEvents-report/:date/:agentId', element: <FalseEventsAGC /> },
      { path: '/agcTrueEvents-report/:date/:agentId', element: <TrueEventsAGC /> },
      { path: '/agcTotalEscalated-report/:date/:agentId', element: <TotalEscalatedAGC /> },
      { path: 'camera-combo-model-config', element:((userType === '9' || userType === '40' || userType === '2') ? <CameraModelComboConfig /> : <Navigate to="/404" replace />) },
    ]
  }
  ]

  // Restricted clients (see utils/clientRouteAccess) may only open a fixed set of
  // pages; any other route inside the authenticated layouts falls back to their
  // landing page.
  const restrictedLandingPage = getRestrictedLandingPage(userData.client_id);
  const applyClientPageRestriction = (layouts) => {
    if (!isClientRestricted(userData.client_id)) return layouts;
    return layouts.map((layout) => ({
      ...layout,
      children: (layout.children || []).map((route) =>
        isPageAllowedForClient(userData.client_id, route.path)
          ? route
          : { ...route, element: <Navigate to={restrictedLandingPage} replace /> }
      )
    }));
  };

  const LOGO_LAYOUT = [{
    path: '/',
    element: <LogoOnlyLayout />,
    children: [
      { path: '/', element: <Navigate to="/login" /> },
      { path: 'auto-login', element: <AutoLogin setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData} /> },
      { path: 'login', element: <Login setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData} setAuthId={setAuthId} /> },
      { path: 'signin', element: <Signin setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData} setAuthId={setAuthId} /> },
      
      { path: 'register', element: <Register/>},
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to="/login" /> },
      { path: 'verificationpage', element: <VerificationPage/>}
    ]
  }]

  const UPGRADE_LAYOUT = [{
    path: '/',
    element: <LogoOnlyLayout />,
    children: [
      { path: '/', element: <Navigate to="/licence" /> },
      { path: 'auto-login', element: <AutoLogin setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData} /> },
      { path: 'login', element: <Login setToken={setToken} setAccess={setAccess} setUserType={setUserType} setuserData={setuserData}/> },
      { path: 'register', element: <Register/>},
      { path: 'licence', element: <LicenceUpgrade /> },
      { path: '404', element: <NotFound /> },
      { path: 'verificationpage', element: <VerificationPage/>},
      { path: '*', element: <Navigate to="/licence" /> }
    ]
  }]
  
  const DEFAULT_RDT = { path: '*', element: <Navigate to="/404" replace /> }
  const ESCALATED_RDT = { path: 'escalatedVideo', element: <EscalatedVideo/>}
  const VIDEO_STREAM_PLAYER_RDT = { path: 'videoStreamPlayer', element: <VideoStreamPlayer/>}
  const RESET_PASSWORD_RDT =  { path: 'resetpassword', element: <ResetPassword/>}
  const SHARED_FOOTAGE_RDT = { path: 'shared-footage/:token', element: <SharedFootage /> }
  // && parseInt(authId) === 1)
  const RUTS = [...(token && parseInt(authId) === 1)  ? (access ? applyClientPageRestriction(DASH_LAYOUT) : UPGRADE_LAYOUT) : LOGO_LAYOUT, DEFAULT_RDT, ESCALATED_RDT, RESET_PASSWORD_RDT, VIDEO_STREAM_PLAYER_RDT, SHARED_FOOTAGE_RDT]
  return useRoutes(RUTS);
}
